import { Component } from '@angular/core';

@Component({
	selector: 'sb-order-giftcard-processing',
	templateUrl: 'order-giftcard-processing.html',
})
export class OrderGiftcardProcessingComponent {}
